import { DprActivitiesGridContainerComponent } from './dpr-activities-grid-container/dpr-activities-grid-container.component';
import { DprActivitiesPageComponent } from './dpr-activities-page/dpr-activities-page.component';
import { DprDetailsPageComponent } from './dpr-details-page/dpr-details-page.component';
import { DprHsePageComponent } from './dpr-hse-page/dpr-hse-page.component';
import { DprWeatherPageComponent } from './dpr-weather-page/dpr-weather-page.component';
import { DprPersonnelPageComponent } from './dpr-personnel-page/dpr-personnel-page.component';
import { DprConsumablesPageComponent } from './dpr-consumables-page/dpr-consumables-page.component';
import { DprSummaryPageComponent } from './dpr-summary-page/dpr-summary-page.component';
import { DprProgressPageComponent } from './dpr-progress-page/dpr-progress-page.component';
import { DprProgressWithoutTargetPageComponent } from './dpr-progress-without-target-page/dpr-progress-without-target-page.component';
import { DprAppendixPageComponent } from './dpr-appendix-page/dpr-appendix-page.component';
import { DprForecastActivitiesPageComponent } from './dpr-forecast-activities-page/dpr-forecast-activities-page.component';
import { DprEditForecastActivityDialogEditComponent } from '@dpr-details/components/dpr-edit-forecast-activity-dialog-edit/dpr-edit-forecast-activity-dialog-edit.component';
import { DprHiddenPageComponent } from './dpr-hidden-page/dpr-hidden-page.component';
import { DprStatusTrackerPageComponent } from './dpr-status-tracker-page/dpr-status-tracker-page.component';
import { DprStatusTrackerGridContainerComponent } from './dpr-status-tracker-grid-container/dpr-status-tracker-grid-container.component';
import { DprTableOfColumnsPageComponent } from './dpr-table-of-columns-page/dpr-table-of-columns-page.component';
import { DprFreeTextFieldsPageComponent } from './dpr-free-text-fields-page/dpr-free-text-fields-page.component';

export {
  DprDetailsPageComponent,
  DprActivitiesPageComponent,
  DprActivitiesGridContainerComponent,
  DprStatusTrackerPageComponent,
  DprStatusTrackerGridContainerComponent,
  DprConsumablesPageComponent,
  DprWeatherPageComponent,
  DprHsePageComponent,
  DprPersonnelPageComponent,
  DprSummaryPageComponent,
  DprProgressPageComponent,
  DprProgressWithoutTargetPageComponent,
  DprTableOfColumnsPageComponent,
  DprAppendixPageComponent,
  DprForecastActivitiesPageComponent,
  DprEditForecastActivityDialogEditComponent,
  DprHiddenPageComponent,
  DprFreeTextFieldsPageComponent,
};

export const containerComponents = [
  DprDetailsPageComponent,
  DprActivitiesPageComponent,
  DprStatusTrackerPageComponent,
  DprStatusTrackerGridContainerComponent,
  DprActivitiesGridContainerComponent,
  DprConsumablesPageComponent,
  DprWeatherPageComponent,
  DprHsePageComponent,
  DprPersonnelPageComponent,
  DprSummaryPageComponent,
  DprProgressPageComponent,
  DprProgressWithoutTargetPageComponent,
  DprTableOfColumnsPageComponent,
  DprAppendixPageComponent,
  DprForecastActivitiesPageComponent,
  DprEditForecastActivityDialogEditComponent,
  DprHiddenPageComponent,
  DprFreeTextFieldsPageComponent,
];
